import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import SvgColor from 'src/components/svg-color';
import { useAuthContext } from 'src/auth/hooks';
import Iconify  from 'src/components/iconify/index';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const iconCustom = (name) => (
  <Iconify  icon= {name} />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  business: icon('mdi:business')
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { user: dataUser } = useAuthContext();
  let dataFilteredWithPermission = [];
  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: 'Administracion',
        items: [
          { title: 'Usuarios', path: paths.dashboard.user.list, icon: ICONS.user, componente: 'Usuarios', },
          { title: 'Roles', path: paths.dashboard.roles.list, icon: ICONS.job, componente: 'Roles', },
          { title: 'Relacion servicio/rol', path: paths.dashboard.relationRolService.list, icon: ICONS.menuItem, componente: 'ServicioRol', },
          { title: 'Empresas', path: paths.dashboard.companies.list, icon: ICONS.banking, componente: 'Empresas', },
          { title: 'Organizaciones', path: paths.dashboard.organization.list, icon: iconCustom('mdi:business'), componente: 'Organizaciones', },
          { title: 'Productos', path: paths.dashboard.products.list, icon: iconCustom("fluent-mdl2:product-variant"), componente: 'Productos', },
          { title: 'Configuracion FEL', path: paths.dashboard.settingFel.list, icon: iconCustom("tdesign:file-setting"), componente: 'ConfiguracionFel', },
          { title: 'Onboarding', path: paths.dashboard.onboarding.list, icon: iconCustom("mdi:list-box"), componente: 'Onboarding', },

        ],
      },
      {
        subheader: 'Procesos',
        items: [
          { title: 'Clientes', path: paths.dashboard.clients.list, icon: ICONS.invoice, componente: 'Clientes',  },
          { title: 'Transacciones', path: paths.dashboard.transactionsClients.list, icon: iconCustom("fa6-solid:money-bill-transfer"), componente: 'Transacciones',  },
          { title: 'Historico', path: paths.dashboard.history.list, icon: ICONS.analytics, componente: 'Historico',  },
        ],
      },
    ],
    []
  );

  if(dataUser) {
    const componentsAccessUser = dataUser?.rutas?.map(ruta => {
      let components = [];
      if(ruta.subMenu) {
        components = ruta.subMenu.map((component) => (component.componente.toLowerCase()))
      }
      else {
        components = ruta.componente.toLowerCase();
      }
      return components;
    }).flat();
    
    dataFilteredWithPermission = data.map((item) => {
      let itemsFilteres = {};
      if(item.items.length > 0) {
        itemsFilteres = item.items.filter((servicio) => (componentsAccessUser.includes(servicio.componente.toLowerCase())) );
      }
      return {
        items: itemsFilteres,
        subheader:  item.subheader,
      }
    });
    
    dataFilteredWithPermission = dataFilteredWithPermission.filter((array) => (array.items.length>0));
    
  }

  return dataFilteredWithPermission || data;
}
